import React from "react";
import { motion } from "framer-motion";
import { Space, Typography, Divider } from "antd";
import { FaArrowLeft, FaClock, FaChair, FaMapMarkerAlt } from "react-icons/fa";
import "./style_new.css";

const { Text } = Typography;

const Flight = ({ depCity, arrCity, fClass, duration }) => {
  return (
    <motion.div
      className="flight-info"
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3 }}
      whileHover={{ scale: 1.02 }}
    >
      <div className="flight-route-container">
        {/* Origin */}
        <motion.div
          className="origin"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.1 }}
        >
          <Space direction="vertical" size={2} align="center">
            <FaMapMarkerAlt className="location-icon origin-icon" />
            <Text className="city-name" strong>
              {depCity}
            </Text>
            <Text className="city-label" type="secondary">
              יציאה
            </Text>
          </Space>
        </motion.div>

        {/* Direction Arrow */}
        <motion.div
          className="direction"
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.2 }}
          whileHover={{
            scale: 1.1,
            rotate: [0, 5, -5, 0],
          }}
        >
          <div className="arrow-container">
            <FaArrowLeft className="direction-arrow" />
            <div className="flight-path-line" />
          </div>
        </motion.div>

        {/* Flight Duration & Class */}
        <motion.div
          className="flight-duration"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          <Space direction="vertical" size={2} align="center">
            <div className="duration-container">
              <Space align="center" size={4}>
                <FaClock className="duration-icon" />
                <Text className="duration-text" strong>
                  {duration}
                </Text>
              </Space>
            </div>

            <Divider className="duration-divider" />

            <div className="class-container">
              <Space align="center" size={4}>
                <FaChair className="class-icon" />
                <Text className="class-text" type="secondary">
                  {fClass}
                </Text>
              </Space>
            </div>
          </Space>
        </motion.div>

        {/* Direction Arrow 2 */}
        <motion.div
          className="direction"
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.4 }}
          whileHover={{
            scale: 1.1,
            rotate: [0, -5, 5, 0],
          }}
        >
          <div className="arrow-container">
            <FaArrowLeft className="direction-arrow" />
            <div className="flight-path-line" />
          </div>
        </motion.div>

        {/* Destination */}
        <motion.div
          className="destination"
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.5 }}
        >
          <Space direction="vertical" size={2} align="center">
            <FaMapMarkerAlt className="location-icon destination-icon" />
            <Text className="city-name" strong>
              {arrCity}
            </Text>
            <Text className="city-label" type="secondary">
              הגעה
            </Text>
          </Space>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default Flight;
